export default class HeaderCtrl {

  constructor ($scope, $http, $timeout, $resource, $location, MenuConstant, UserInfoConstant, permissionList, permissions, $state, $rootScope, $translate, $cookies, $mdSidenav, GlobalConfig, GlobalSrv, $mdDialog, $interval, $stateParams) {
    var localenv = require('../local.env.json')
    const stages = GlobalConfig.workplanStagesNames
    $scope.roleClick = roleClick
    $scope.notificationUserInboxClick = notificationUserInboxClick
    $scope.notificationUserInboxAllClick = notificationUserInboxAllClick
    $scope.notificationUserInboxAll = []
    $scope.notificationUserInboxDetailClick = notificationUserInboxDetailClick
    $scope.toUpdate = toUpdate
    $rootScope.showChat = false
    $rootScope.showComments = false
    $rootScope.showReflections = false

    $timeout(function () {
      $interval(function () {
        $scope.notificationsChat = $rootScope.chatNotifications
      // $scope.notificationsOberv = 5
      // $scope.notificationsReflex = 2
        $scope.totalNotifications = $scope.notificationsChat // + $scope.notificationsOberv + $scope.notificationsReflex
        $scope.rolId = $cookies.getObject('hasRoleValue')
      }, 3000)
    }, 1500)

    
    $scope.menuTitle = ''
    if ($state.current && $state.current.params && $state.current.params.stage) {
      if(stages[$state.current.params.stage] != undefined){
        $scope.menuTitle = 'Plan de trabajo - ' + $state.current.data.title + ' - Etapa de ' + stages[$state.current.params.stage]
      }else{
        $scope.menuTitle = 'Plan de trabajo - ' + $state.current.data.title + ' - Etapa de ' + stages[$location.search().currentStage]
      }
    }

    $scope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
      if ($state.current && $state.current.params && $state.current.params.stage) {
        if(stages[$state.current.params.stage] != undefined){
          $scope.menuTitle = 'Plan de trabajo - ' + $state.current.data.title + ' - Etapa de ' + stages[$state.current.params.stage]
        }else{
          $scope.menuTitle = 'Plan de trabajo - ' + $state.current.data.title + ' - Etapa de ' + stages[$location.search().currentStage]
        }
      } else {
        $scope.menuTitle = ''
      }
    })

    $scope.lang = $cookies.get('lang')
    $scope.languages = [
      {
        'key': 'es',
        'value': 'Spanish',
        'src': 'assets/images/flags/es.png'
      },
      {
        'key': 'en',
        'value': 'English',
        'src': 'assets/images/flags/en.png'
      }
    ]

    if (typeof $scope.lang === 'undefined') $scope.lang = 'es'

    $translate.use($scope.lang)

    $scope.languageHeader = updateLanguageKey($scope.lang, $scope.languages)

    /* $scope.updateLanguage = function() {
    console.log($scope.language)
    $translate.use($scope.language.key);
    }; */

    $scope.updateLanguage1 = function (key) {
      console.log(key)
      $translate.use(key)
      $scope.languageHeader = updateLanguageKey(key, $scope.languages)
      console.log($scope.languageHeader)
    }

    $scope.asideParentClick = function () {
      $('slick').slick('refresh')
      $rootScope.$emit('CallMyMethod', {})
    }

    $scope.asideParentClickfullScreen = function () {
      $('slick').slick('refresh')
      $rootScope.$emit('CallMyMethodfullscreen', {})
    }

    $rootScope.$on('$translateChangeSuccess', function (event, data) {
      console.log('translateChangeSucces')
      var language = data.language
      $cookies.put('lang', language)
      $rootScope.lang = language
      // $rootScope.$emit("CallMyMethod", {});
    })

    function updateLanguageKey (key, value) {
      for (var i in value) {
        if (value[i].key === key) {
          return value[i]
        }
      }
    }

    $rootScope.$on('CallSetNotifications', function (event, notificationUserInbox) {
      $scope.notificationUserInbox = notificationUserInbox
    })

    $rootScope.$on('CallSetCountNotificationsUserInboxNoRead', function (event, countNotificationsUserInboxNoRead) {
      $scope.countNotificationsUserInboxNoRead = countNotificationsUserInboxNoRead
    })

    $rootScope.$on('CallMyMethodRoles', function (event, roles) {
      $scope.roles = roles
    })

    function roleClick (role) {
      $cookies.put('roleName', role.role_name)
       $cookies.remove('isIntialLogin')
      switch (role.role_id) {
        case GlobalConfig.userRolesIds.consultant:
        case GlobalConfig.userRolesIds.approver:
        case GlobalConfig.userRolesIds.reviewer:
        case GlobalConfig.userRolesIds.teacher:
          $cookies.put('hasRoleValue', true)
          break
        default:
          $cookies.put('hasRoleValue', false)
          break
      }

      $cookies.put('hasRoleId', role.role_id)

      $rootScope.$emit('rootScope:ReportEmit', 'ReportEmit!'); // $rootScope.$on     
      $state.go('fullscreen.welcomeHome', {}, {reload: true})  
    }

    /* $scope.sessionChat = function(bool){
      $cookies.put('onlineStatus',true);
      $cookies.put('status',bool);
    } */

    $scope.openChat = function (bool) {
      $scope.rolSelect = $cookies.getObject('hasRoleId')

      switch ($scope.rolSelect) {
        case GlobalConfig.userRolesIds.consultant:
        case GlobalConfig.userRolesIds.approver:
        case GlobalConfig.userRolesIds.reviewer:
        case GlobalConfig.userRolesIds.teacher:
          $rootScope.showChat = true
          $rootScope.openContacts = true
          $rootScope.showComments = false
          $rootScope.showReflections = false
          break
        default:
          $rootScope.showChat = false
          break
      }
    }

    $scope.openComments = function () {
      $scope.rolSelect = $cookies.getObject('hasRoleId')

      switch ($scope.rolSelect) {
        case GlobalConfig.userRolesIds.consultant:
        case GlobalConfig.userRolesIds.approver:
        case GlobalConfig.userRolesIds.reviewer:
        case GlobalConfig.userRolesIds.teacher:
          $rootScope.showChat = false
          $rootScope.showComments = true
          $rootScope.showReflections = false
          break
        default: break
      }
    }

    $scope.openReflections = function () {
      $scope.rolSelect = $cookies.getObject('hasRoleId')

      switch ($scope.rolSelect) {
        case GlobalConfig.userRolesIds.consultant:
        case GlobalConfig.userRolesIds.approver:
        case GlobalConfig.userRolesIds.reviewer:
        case GlobalConfig.userRolesIds.teacher:
          $rootScope.showChat = false
          $rootScope.showComments = false
          $rootScope.showReflections = true
          break
        default: break
      }
    }

    function notificationUserInboxClick (varNotificationUserInbox) {
    // update is_read
      udpateIsReadNotificationUserInbox(varNotificationUserInbox, popUpNotification)
    }

    function popUpNotification (varNotificationUserInbox) {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          console.log(varNotificationUserInbox)
          $scope.msgInboxDate = varNotificationUserInbox.dt_creationDate
          $scope.msgInboxName = varNotificationUserInbox.ds_name
          $scope.msgInboxDescription = varNotificationUserInbox.ds_description
          $scope.close = () => $mdDialog.hide()
        }],
        template: require('./notificationUserInboxDetailModal.html'),
        clickOutsideToClose: true
      })
    }

    function popUpNotificationAll (varNotificationUserInbox) {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.msgInboxIdUser = varNotificationUserInbox.id_user
          $scope.msgInboxDate = varNotificationUserInbox.dt_creationDate
          $scope.msgInboxName = varNotificationUserInbox.ds_name
          $scope.msgInboxDescription = varNotificationUserInbox.ds_description
          $scope.notificationUserInboxAllClick = notificationUserInboxAllClick
          $scope.close = () => {
            $mdDialog.hide()
          }
        }],
        template: require('./notificationUserInboxDetailAllModal.html'),
        clickOutsideToClose: true
      })
    }

    function notificationUserInboxAllClick (id_user) {
      let header = {userId: $cookies.getObject('currentUser').id}
      GlobalSrv.getUserInboxAllNoRead.get(header).$promise.then(function (dataReturn) {
        if (dataReturn.status == true) {
          $mdDialog.show({
            controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
              $scope.allData = dataReturn.data
              $scope.notificationUserInboxDetailClick = notificationUserInboxDetailClick
              $scope.close = () => {
                $mdDialog.hide()
              }
            }],
            template: require('./notificationUserInboxAllModal.html'),
            clickOutsideToClose: true
          })
        } else {
          $scope.notificationUserInboxAll = []
        }
      }, function (dataReturn) {
        console.log(dataReturn)
      })
    }

  function cleanNotificationUserInbox(varNotificationUserInbox){
    for (var i in $scope.notificationUserInbox){
      if(varNotificationUserInbox.id_code == $scope.notificationUserInbox[i].id_code){
        $scope.notificationUserInbox.splice(i, 1)
        break
      }
    }
  }

	function udpateIsReadNotificationUserInbox (varNotificationUserInbox, callback) {
	  GlobalSrv.updateNotificationReadingMessagesUserInbox.update({
      msgIdCode: varNotificationUserInbox.id_code
    }).$promise.then(function (dataReturn) {
		console.log(dataReturn)
		if (dataReturn.status) {
			//reload
        $rootScope.countNotificationsUserInboxNoRead();
        $rootScope.$on('CallSetCountNotificationsUserInboxNoRead', function (event, countNotificationsUserInboxNoRead) {
          $scope.countNotificationsUserInboxNoRead = countNotificationsUserInboxNoRead;
        })
        cleanNotificationUserInbox(varNotificationUserInbox)
        callback(varNotificationUserInbox)
		} else {
		  console.log('error de comunicacion con el servidor')
		}
	  }, function (data) {
		console.log(data)
	  })
	}
    function notificationUserInboxDetailClick (varNotificationUserInbox) {
    // update is_read
      udpateIsReadNotificationUserInbox(varNotificationUserInbox, popUpNotificationAll)
    }

    function toUpdate (){
      let role = {
        role_name : 'Profesor',
        role_id   : 13
      }

      $cookies.put('roleName', role.role_name)
       $cookies.remove('isIntialLogin')
      switch (role.role_id) {
        case GlobalConfig.userRolesIds.consultant:
        case GlobalConfig.userRolesIds.approver:
        case GlobalConfig.userRolesIds.reviewer:
        case GlobalConfig.userRolesIds.teacher:
          $cookies.put('hasRoleValue', true)
          break
        default:
          $cookies.put('hasRoleValue', false)
          break
      }

      $cookies.put('hasRoleId', role.role_id)

      $rootScope.$emit('rootScope:ReportEmit', 'ReportEmit!'); // $rootScope.$on
    // $state.reload()
      $state.go('fullscreen.welcomeHome')
      $state.reload()

         // let header = {userId: UserInfoConstant[0].details[0].user.id}
         // GlobalSrv.getUserInfo.get(header).$promise.then((dataReturn) => {

         //   $cookies.putObject('subModuleId', dataReturn.summodules)
         //   $cookies.putObject('stageId', dataReturn.stages)
         //   $cookies.putObject('reviewers', dataReturn.reviewers)
         //   $cookies.put('isReproved', dataReturn.isApproved)
         //   $cookies.put('isApproved', dataReturn.isReproved)
         //   $scope.rut = dataReturn.dsIdentification
         //   // $cookies.remove('isIntialLogin')
    
         // })
    } 
  }
}

HeaderCtrl.$inject = ['$scope', '$http', '$timeout', '$resource', '$location', 'MenuConstant', 'UserInfoConstant', 'permissionList', 'permissions', '$state', '$rootScope', '$translate', '$cookies', '$mdSidenav', 'GlobalConfig', 'GlobalSrv', '$mdDialog', '$interval', '$stateParams']



// WEBPACK FOOTER //
// ./src/headerCtrl.js